var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',[(_vm.src)?_c('v-uni-image',{style:(_vm.style),attrs:{"lazy-load":true,"src":_vm.src,"mode":_vm.mode}}):_c('v-uni-view',{staticClass:"iconfont no-img flexs align-center ",style:(_vm.style)},[_vm._v("")])],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }